import script from "./OrderShipTo.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderShipTo.vue?vue&type=script&setup=true&lang=js"

import "./OrderShipTo.vue?vue&type=style&index=0&id=aeb00f8c&lang=scss"

const __exports__ = script;

export default __exports__